<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Processos"
  [p-disclaimer-group]="disclaimerGroup" [p-filter]="filterSettings"
  p-subtitle="Consulte informações sobre processos judiciais.">
  <p class="po-font-subtitle">Digite o número do processo para buscar informações detalhadas.</p>

  <!-- Mensagem de Aguarde -->
  @if (mensagemAguarde) {
    <div class="alert-banner po-mb-3">
      <i class="an an-spinner-gap"></i>
      <p>{{ mensagemAguarde }}</p>
    </div>
  }

  <po-divider></po-divider>

  <!-- Resultados -->
  @if (processoData) {
    <div class="po-row po-mb-4 po-mt-3">
      <div>
        <po-loading-overlay [hidden]="!loading"></po-loading-overlay>
      </div>
      <!-- Resumo do Processo -->
      <div class="po-lg-12 po-mb-3">
        <po-widget p-title="Resumo do Processo">
          <div class="po-p-3 summary-text">
            {{ getResumo() }}
          </div>
        </po-widget>
      </div>
      <!-- Movimentações -->
      @if (movimentacoesAgrupadas.length > 0) {
        <div class="po-lg-12">
          <po-widget p-title="Movimentações">
            <div class="po-p-3">
              @for (grupo of movimentacoesAgrupadas; track grupo) {
                <div class="timeline-group">
                  <div class="timeline-month">
                    <h3 class="po-font-subtitle po-mb-1">{{ grupo.mesAno }}</h3>
                  </div>
                  @for (mov of grupo.movimentacoes; track mov) {
                    <div class="timeline-item">
                      <span class="timeline-day">{{ mov.dia }}</span>
                      <span class="timeline-content">{{ mov.content }}</span>
                    </div>
                  }
                </div>
              }
            </div>
          </po-widget>
        </div>
      }
    </div>
  }
</po-page-list>

